import { Component, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { DxDataGridComponent } from 'devextreme-angular';
import { FusService } from '../../../services/formulacion/fus.service';
import { ReversionService } from '../../../services/formulacion/reversion.service';
import { UtilHelper } from '../../../_helpers/util';
import { environment } from '../../../../environments/environment';
import { GeneralService, PoaTechoService } from 'src/app/services/service.index';
declare var jQuery: any;
declare var toastr;

@Component({
  selector: 'app-pla-fus',
  templateUrl: './pla-fus.component.html',
  styleUrls: [],
  providers: [FusService]
})
export class PlaFusComponent implements OnInit {
  @ViewChild(DxDataGridComponent) dataGrid: DxDataGridComponent;
  idSolicitud: number = 0;
  nroFus: string;
  reversiones: any = [];
  fuses: any[];
  fus: any;
  tipo_agregacion_id: number = 1;
  dataResourceAgregacion: any[];
  dataResourceObs: any[];
  dataSeg: any = [];
  fusSeg: string = '';
  popupVisibleSeg: boolean = false;
  estadosFilter: any = [];
  estado: number = 12;
  popupVisibleReversiones: boolean = false;
  popupVisibleDetail: boolean = false;
  popupVisibleDel: boolean = false;
  popupVisibleR: boolean = false;
  model: any = { id: 0, observaciones: '', estado_id: '', id_solicitud: 0, observacion_id: 0 };
  estados: any[] = [];
  clicked: boolean = false;
  baseUrl = environment.apiEndpoint;
  baseUrld = environment.apiEndpoint.substring(0, environment.apiEndpoint.length - 4);
  fusReversion: any;
  jusReversion = false;
  hasError: any;

  estadoAux: number = 0;
  esNuevaObs: boolean = false;
  rol: number;
  constructor(private route: ActivatedRoute, private _fs: FusService, private _rs: ReversionService, private _gs: GeneralService, private _ts: PoaTechoService) {



    this.getEstadosByUsuario();
    this.resetErrors();
    let u = JSON.parse(localStorage.getItem('u'));
    this.nroFus = '';
    this.getTipoAgregacion();
    if (u != null) {
      this.rol = u.rol;
      this.tipo_agregacion_id = 1;

      if (this.rol == 12 || this.rol == 15) {
        this.estadosFilter = [{ id: 11, descripcion: 'Enviado UE' }, { id: 12, descripcion: 'AprobAprobado UE' }, { id: 14, descripcion: 'Aprobado' }, { id: 15, descripcion: 'Observado' }, { id: 18, descripcion: 'Anulado' }];
        this.estados = [{ id: 14, descripcion: 'Aprobado' }, { id: 15, descripcion: 'Observado' }, { id: 18, descripcion: 'Anulado' }];
      }

      if (this.rol == 23)
        this.estados = [{ id: 14, descripcion: 'Aprobado' }, { id: 15, descripcion: 'Observado' }, { id: 18, descripcion: 'Anulado' }, { id: 19, descripcion: 'Aprobado Otras UE' }];

    }






  }

  ngOnInit() {
  }



  getTipoAgregacion() {
    this._ts.getTipoAgregacion().subscribe(
      (response) => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {
          this.dataResourceAgregacion = result.data;

        } else {
          this.dataResourceAgregacion = [];
        }
      },
      (error) => { console.log('Error', error); });
  }

  refreshDataGridTipo(e) {
    this.estado = e.value;
    this.tipo_agregacion_id = e.value;
    this.getListFus(this.estado, this.tipo_agregacion_id);
    this.dataGrid.instance.refresh();
  }

  getEstadosByUsuario() {
    this._fs.getFusEstadosByUsuario().subscribe(
      (response) => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {
          this.estadosFilter = result.data;
          this.getListFus(this.estado, this.tipo_agregacion_id);
        }
        else { this.estadosFilter = []; }
      },
      (error) => { console.log('Error', error); });
  }

  getListFus(id: number, tipo_agregacion_id: number) {
    this._fs.getListFusByEstadoId(id, tipo_agregacion_id).subscribe(
      (response) => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {
          this.fuses = result.data;
        }
        else { this.fuses = []; }
      },
      (error) => { console.log('Error', error); });
  }

  getFusByNroFus(nroFusV: string) {

    this.nroFus = nroFusV;
    if (this.nroFus.length > 3) {
      this._fs.getFusAllByEstadoNroFUS(this.nroFus).subscribe(
        (response) => {
          let result = UtilHelper.responses(response);
          if (result.status == 200) {
            this.fuses = result.data;
          }
          else { this.fuses = []; }
        },
        (error) => { console.log('Error', error); });
    }
  }

  getFusById(id: string, id_solicitud: number) {
    this.idSolicitud = id_solicitud;
    this.resetErrors();
    this._fs.getFusAdmById(id).subscribe(
      (response) => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {
          this.fus = result.data;
          this.model.estado_id = '';
          this.estadoAux = result.data.estado_id;
          this.popupVisibleDetail = true;
        }
      },
      (error) => { console.log('Error', error); });
  }

  onToolbarPreparing(e) {
    e.toolbarOptions.items.unshift({
      location: 'before',
      template: 'acciones'
    },
      {
        location: 'before',
        widget: 'dxButton',
        options: {
          text: 'Actualizar',
          onClick: this.refreshDataGrid2.bind(this)
        }
      });
  }

  showModalSeg(id: string, fus: string) {
    this.fusSeg = fus;
    this._fs.getSeguimientoByFusId(id).subscribe(
      (response) => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) { this.dataSeg = result.data; }
      },
      (error) => { console.log('Error', error); });
    this.popupVisibleSeg = true;
  }

  refreshDataGrid(e) {
    this.getListFus(e.value, this.tipo_agregacion_id);
    this.dataGrid.instance.refresh();
    this.estado = e.value;
  }

  refreshDataGrid2(e) {
    this.getListFus(this.estado, this.tipo_agregacion_id);
    this.dataGrid.instance.refresh();
  }

  saveEstado() {
    this.model.id = this.fus.id;
    this.model.id_solicitud = this.idSolicitud;
    this.resetErrors();
    if (this.validSave()) {
      this.clicked = true;
      if (this.estadoAux != this.model.estado_id) {
        this._fs.postSetEstadoFusAdm(this.model).subscribe(
          response => {
            let result = UtilHelper.responses(response);
            if (result.status == 200) {
              this.getListFus(this.estado, this.tipo_agregacion_id);
              this.dataGrid.instance.refresh();
              this.model.estado_id = '';
              toastr.success('Datos guardados correctamente.');
              this.clicked = false;
            }
            this.popupVisibleDetail = false;
          },
          (error) => { console.log('Error', error); });
      }
      else {
        this.clicked = false;
        toastr.warning('No se puede cambiar al mismo estado Elegido...');
      }
    }
    else {
      toastr.warning('Existen errores en el llenado');
    }
  }

  validSave() {
    let res = true;
    if (this.model.observaciones == '') {
      this.hasError.observaciones = true; res = false;
    }
    if (this.model.estado_id == 0) {
      this.hasError.estado_id = true; res = false;
    }
    if ((this.model.estado_id != 14) && (this.model.estado_id != 19)) {
      if (this.model.observacion_id == 0) {
        this.hasError.observacion_id = true; res = false;
      }
    }
    return res;
  }

  resetErrors() {
    this.hasError = { observaciones: false, estado_id: false, observacion_id: false };
  }

  getFusReversionesById(id: string) {
    this.resetErrors();
    this._rs.getFusReversionesById(id).subscribe(
      (response) => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {
          this.fusReversion = result.data;
          this.popupVisibleR = true;
        }
      },
      (error) => { console.log('Error', error); });
  }

  saveReversion() {
    this.jusReversion = false;
    if (this.validRev()) {
      this._rs.postFusReversion(this.fusReversion).subscribe(
        response => {
          let result = UtilHelper.responses(response);
          if (result.status == 200) {
            this.getListFus(this.estado, this.tipo_agregacion_id);
            this.dataGrid.instance.refresh();
            toastr.success('Datos guardados correctamente.');
            this.clicked = false;
          }
          this.popupVisibleR = false;
        });
    }
  }

  updateReversion(id: number) {
    let i = this.reversiones.filter(o => o.id == id).map(o => o)[0];
    this._rs.putFusReversion(i).subscribe(
      response => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {
          this.popupVisibleReversiones = false;
          toastr.success('Datos actualizados exitosamente.');
        }
      },
      (error) => { console.log('Error', error); });
  }

  validRev() {
    let res = true, f1 = false, f2 = false;
    if (!UtilHelper.validator(this.fusReversion.justifica_reversion, 'text')) {
      f1 = true;;
    }
    this.fusReversion.detalle.forEach(item => {
      if ((item.revertido < 0))
        f2 = true;
    });

    if (f2) {
      res = false;
      toastr.warning('Los montos no pueden ser ceros');
    }
    if (f1) {
      res = false;
      toastr.warning('Complete la justificación');
    }
    return res;
  }

  getObservaciones(e: any) {
    if (this.model.estado_id != '') {
      if ((e.value == 14) || (e.value == 19)) {
        this.model.observaciones = 'Ninguna';
        this.esNuevaObs = true;
      }
      else if (e.value == 18) {
        this.model.observaciones = '';
        this.esNuevaObs = true;
      }
      else {
        this.model.estado_id = 15;
        this.getObservacionesLista();
        this.esNuevaObs = false;
        this.model.observaciones = '';
        this.model.observacion_id = 0;

      }
    }
  }

  showModalReversiones(id: string, fus: string) {
    this.fusSeg = fus;
    this._rs.getListReversionesByIdFus(id).subscribe(
      (response) => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {
          this.reversiones = result.data;
          this.popupVisibleReversiones = true;
        }
      },
      (error) => { console.log('Error', error); });

  }

  getDescribirObservacion(e: any) {
    this.model.observacion_id = e.value;
    var esNueva = this.dataResourceObs.filter(o => o.id == e.value).map(o => o.descripcion).toString();
    if (esNueva == 'Otro') {
      this.model.observacion = '';
      this.esNuevaObs = true;
    }
    else {
      this.esNuevaObs = false;
      this.model.observaciones = esNueva;
    }
  }

  getObservacionesLista() {
    this._gs.getObservaciones('FUS').subscribe(
      (response) => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {
          this.dataResourceObs = result.data;
        }
        else { this.dataResourceObs = []; }
      },
      (error) => { console.log('Error', error); });
  }

}
